const Asset = {

    // FIELDS
    "asset": "GRN",
    "name": "Name",
    "description": "Description",
    "code": "Code",
    "serial_number": "Serial Number",
    "category": "Category",
    "sub_category": "Sub Category",
    "brand": "Brand",
    "vendor": "Vendor",
    "purchase_date": "Purchase Date",
    "warranty_period": "Warranty Period",
    "location": "Location",
    "sub_location": "Sub Location",
    "status": "Status",
    "search": "Search",
    "qr_code": "QR Code",

    // PAGE HEADER
    "list_title": "Goods Receipt Note (GRN)",
    "filter_title": "GRN Filter",
    "details_title": "GRN Details",

    // TABLE HEADER
    "table_name": "Name",
    "table_code": "Code",
    "table_category": "Category",
    "table_location": "Location",
    "table_status": "Status",

    // ERROR
    "error_name": "Enter GRN",
    "error_code": "Enter Code",
    "error_serial_number": "Enter Serial Number",
    "error_category": "Select Category",
    "error_sub_category": "Select Sub Category",
    "error_brand": "Select Brand",
    "error_vendor": "Select Vendor",
    "error_purchase_date": "Select Purchase Date",
    "error_warranty_period": "Enter Warranty Period",
    "error_location": "Select Location",
    "error_sub_location": "Select Sub Location",
    "error_status": "Select Status",

}

export default Asset;

